/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { useCreateDocumentWidget } from '../api/documentWidgets';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import useToastNotification from './useToastNotification';

export const useAddDocumentWidget = (handleDrawerClose, files) => {
  const { t } = useTranslation();
  const { mutate, isSuccess, isLoading, isError } = useCreateDocumentWidget();

  const schema = yup
    .object()
    .shape({
      subtitle: yup.string().required(t('NameRequired')),
      title: yup.string().required(t('TitleRequired')),
      language: yup.string().required(t('languageRequired')),
      files: yup.object().shape({
        image: yup.mixed().required('A file is required'),
        file: yup.mixed().required('A file is required'),
      }),
    })
    .required();

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    register,
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      defaultValues: {
        subtitle: '',
        title: '',
        language: '',
        files: {
          image: null,
          file: null,
        },
      },
    },
    resolver: yupResolver(schema),
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    reset({
      subtitle: '',
      title: '',
      language: '',
      files: {
        image: null,
        file: null,
      },
    });
  }, [reset]);

  useToastNotification({
    isShow: isSuccess,
    loading: isLoading,
    messageKey: 'successAddedDocumentWidget',
    variant: 'success',
  });

  useToastNotification({
    isShow: isError,
    loading: isLoading,
    messageKey: 'errorAddedDocumentWidget',
    variant: 'error',
  });

  const onSubmit = (data) => {
    const formData = new FormData();

    formData.append('subtitle', data.subtitle);
    formData.append('title', data.title);
    formData.append('language', data.language);

    if (files.file) {
      formData.append('file', files.file);
    }
    if (files.image) {
      formData.append('image', files.image);
    }
    mutate({ data: formData });
    reset();
    handleDrawerClose();
  };

  return {
    handleSubmit,
    control,
    onSubmit,
    isLoading,
    errors,
    register,
  };
};
